<template>
    <div class="feed diary-project-post">
        <card
            :hide-content="true"
            icon="mdi-newspaper-variant-outline"
            :label-top-left="$t('msg.followTheProgressOfPeople')"
        >
            <template slot="header">
                <filters
                    v-model="filters"
                    :bool-singles="['is_follow']"
                    name="feed"
                    :not-show-in-label="['offset', 'limit']"
                    @clear="clearFilters"
                >
                    <v-switch
                        v-model="filters.is_follow"
                        :label="$t('msg.subscriptions')"
                        dense
                        hide-details
                        @change="loadFeeds()"
                    ></v-switch>
                </filters>
            </template>
        </card>
        <posts
            v-model="posts"
            :with-author="true"
            class="mt-8"
            ref="posts"
            :loading="loading"
        ></posts>
    </div>
</template>

<script>
import Filters from '../../components/ui/Filters';
import Posts from "../../components/block/Talk/Posts";

export default {
    components: {Filters, Posts},
    data() {
        return {
            filters: {
                is_follow: false,
                offset: 0,
                limit: 20
            },
            posts: [],
            loading: false
        }
    },
    methods: {
        clearFilters() {

            this.filters.is_follow = false;

            this.loadFeeds();
        },
        loadFeeds() {
            this.loading = true;

            this.$store.dispatch('loadFeeds', {params: this.filters})
                .then(res => this.posts =  res)
                .finally(() => this.loading = false);
        }
    },
    mounted() {
        this.loadFeeds();
    }
}
</script>